import { useTranslation } from 'next-i18next'

import { GamesStats } from '~/redux/apis/user-stats-api'
import StatsMultiplicationMaster from '~/statistics-v2/components/StatsMultiplicationMaster'
import StatsStackNload from '~/statistics-v2/components/StatsStackNload'
import StatsTreasureTrail from '~/statistics-v2/components/StatsTreasureTrail'
import StatsWindsurfer from '~/statistics-v2/components/StatsWindsurfer'

/**
 * The four game cards. Props only — the caller supplies whose games these are.
 *
 * ⚠ Every card shows a missing figure as `0`, so an absent `stats` reads as a learner who has never
 * played. The caller handles failed and in-flight requests. Needs the `statisticsV2` namespace.
 *
 * `isScoped` says the other three cards are narrowed to one curriculum or grade, which Stack'n Load
 * cannot be — it labels itself so its lifetime figures aren't read as belonging to this grade.
 */
export default function GameStatsPanel({
  isScoped,
  stats,
}: {
  isScoped?: boolean
  stats?: GamesStats
}): React.ReactElement {
  const { t } = useTranslation('statisticsV2')

  return (
    <div className="w-full rounded bg-purple-darker p-4">
      <h2 className="mb-4 text-sm font-black text-white">{t('games.gameStats')}</h2>
      <div className="flex flex-wrap gap-4">
        <StatsTreasureTrail stats={stats?.treasureTrail} />
        <StatsWindsurfer stats={stats?.windSurfer} />
        <StatsMultiplicationMaster stats={stats?.multGame} />
        <StatsStackNload isAllGrades={isScoped} stats={stats?.stacknLoad} />
      </div>
    </div>
  )
}
